import { companyType } from '../D2r';
import { Beats } from './Beat';

export const BeatsD2R = ({ company }: { company: companyType }) => <Beats company={company} />;
